import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeOpenedOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7 2.8H6.3v9.058l5.7 2.367 5.7-2.367zM4.5 7.199v3.911l-2.453-1.019c.216-1.022.56-1.653.976-2.068.328-.328.792-.613 1.477-.824M1.8 13q0-.563.025-1.052L12 16.175l10.175-4.227q.025.489.025 1.052v2c0 2.9-.507 4.261-1.223 4.977S18.9 21.2 16 21.2H8c-2.9 0-4.261-.507-4.977-1.223S1.8 17.9 1.8 15zm19.177-4.977c.415.415.76 1.046.976 2.068l-2.453 1.02V7.198c.685.211 1.149.496 1.477.824M19.5 5.335V1h-15v4.335C1.193 6.118 0 8.366 0 13v2c0 6 2 8 8 8h8c6 0 8-2 8-8v-2c0-4.634-1.193-6.882-4.5-7.665M8.5 8.9h7V7.1h-7z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
EnvelopeOpenedOutlinedSize24Glyph.displayName = 'EnvelopeOpenedOutlinedSize24Glyph';
